<template>
     <div class="column inputBox" style="position: relative;">
      
          <div class="icon"><slot name="icon"></slot></div>
          
          <input
              class="searchInput"
              style="margin: 0;transition: none;"              
              ref="input"
              :class="{inputIcon: current.id, noBottomBorder: items.length, round, inputIconRound:round && current.id}"                           
              type="text"               
              v-model="searchText"
              :placeholder="placeholder || 'Location'"              
              @input="search">
          
              <!-- @keydown.down="focusHandler" 
              @keydown.up="focusHandler" 
              @keydown.enter.prevent="focusHandler" -->
              
          <!-- clear -->
          <div class="clearicon pointer click" v-if="searchText && !round" @click="clear()"><span>×</span></div>
          <div class="cleariconround pointer click" v-if="searchText && round" @click="clear()"><span>×</span></div>
          
        </div>

        <!-- 

          <Search v-model="query" placeholder="Search" class="w300" height="300px"/>
         -->
</template>
<script>
export default {
   
    data: function () {return {
      current:{},
      timer: undefined,
      items: [],
      focus: null,
      searchText: undefined,
      
    }},

    
    props: {
      modelValue: Number,
      placeholder: String,           
      height: {type:String, default:'300px'},      
      delay: {type: Number, default:0},
      round:Boolean,
    },

    mounted() {
      if (this.modelValue){
        // 
      }
    },

    computed: {
      value(){        
        return `${this.current.name}, ${this.countryTitle[this.current.country]}`
      },

      country(){        
        return this.current.country
      }
    },

    methods: {
      keydowns(){
        console.log('key enter')
      },
      focusHandler(event) {
        switch (event.keyCode) {
          case 13:
            if (!this.focus) {
              this.current = this.items[0]
              this.update()
              return
            }             
              this.current = this.items[this.focus]
              this.update()            
              return
          case 38:
            if (this.focus === null) {
              this.focus = 0;
            } else if (this.focus > 0) {
              this.focus--;
            }
            break;
          case 40:
            if (this.focus === null) {
              this.focus = 0;
            } else if (this.focus < this.items.length - 1) {
              this.focus++;
            }
            break;
        }
      },

      out(){
        console.log('outside')
        this.items=[]
        // this.clear()
      },
      clear(){
        this.current = {}
        this.searchText = undefined
        this.$emit('update:modelValue', undefined)  
        this.$emit('update', undefined)        
        this.$emit('country', undefined)
        this.$emit('city', undefined)
        this.$emit('state', undefined)
        this.items = []
      },
      
       update() {
        this.$emit('update:modelValue', this.current.id)  
        this.$emit('update', this.current)
        this.$emit('country', this.current.country)
        this.$emit('city', this.current.name)
        this.$emit('state', this.current.state)
        if (this.current.country == 'us' && this.current.state){
          this.searchText = `${this.current.name}, ${this.current.state.toUpperCase()}`        
        } else{
          this.searchText = `${this.current.name}, ${this.countryTitle[this.current.country]}`        
        }
        
        // this.dict.cities[this.current.id] = this.current
        this.items = []
      },

      // input
      async wait(fn, delay = 300) {
            return ((...args) => {
              clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                this.timer = null
                fn(...args)
                }, delay)
            })()
      },

      updateValue(e) {
        // console.log('input', e.target.value)
        // this.wait(() => { }, this.delay);
      },



      async search(){
        let res = await this.api.send('geo', {q: this.searchText})
        
      console.log(res)
      if (res.error){
        console.log(res.error)        
        return
      }
      this.items = res.resp
      /* {
		    "country": "it",
		    "flag": "🇮🇹",
		    "id": 3171457,
		    "name": "Parma"
		  }, */
    },


    },
}
</script>

<style scoped>
.item {
  font-size: 15px;
  margin-top: -1px;
  margin-left: 2px;
}
.rounditem {
  font-size: 13px;
  margin-top: -1px;
  margin-left: 2px;
}

.inputBox {
  margin: 0px 0 12px;
  margin: 0px 0 0px;
}

.round{
  padding: 3px 16px; 
  border-radius: 50px; 
  font-size: 13px; 
  width: 100%;
}

/* input */
.autocomplete {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: var(--back);
  position: absolute;
  z-index: 1000;
  /* margin-top: 30px; */
  text-align: left;
  align-items: flex-start;
  justify-content: flex-start;
  border-top: 1px dashed var(--g1);
}

.itembox {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  text-align: left;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  /* background-color: var(--back); */
  background: var(--input);
  padding: 2px 0px 2px 6px;
}

.itembox:hover, .itembox.active {
  background-color: var(--g1);
}

/* .autocomplete div p {
  padding: 2px 8px;
  text-align: left;
} */

.noBottomBorder {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.round.noBottomBorder {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.text {
  width: 100%;
  position: relative;
  padding: 0px 0;
  margin: 0;
}

.input {
  padding: 5px 12px 8px;
  border-radius: 8px;
  background: var(--g05);
}

.clear {
  background: none;
}

.inputIcon {
  padding-left: 50px;
}

.icon {
  height: 20px;
  width: auto;
  position: absolute;
  top: 11px;
  left: 12px;
  border-radius: 4px;
}

.inputIconRound {
  padding-left: 38px;
}

.roundicon {
  height: 18px;
width: auto;
position: absolute;
top: 7px;
left: 9px;
border-radius: 4px;
}

.clearicon {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  width: 22px;
  position: absolute;
  top: 11px;
  right: 7px;
  border-radius: 100px;
  background-color: var(--g1);
}

.clearicon span {
  position: absolute;
  font-size: 12px;
  font-weight: 500;
  color: var(--g3);
  margin-top: -1px;
}

.cleariconround {
  cursor: pointer;
-webkit-user-select: none;
-moz-user-select: none;
user-select: none;
display: flex;
align-items: center;
justify-content: center;
height: 17px;
width: 17px;
position: absolute;
top: 7px;
right: 10px;
border-radius: 100px;
background-color: var(--g1);
}

.cleariconround span {
  position: absolute;
font-size: 12px;
font-weight: 500;
color: var(--g3);
margin-top: -1px;
margin-left: 1px;
}

.iconpadding {
  padding-left: 30px;
}

div.focus {
  border: 1px solid blue;
}

</style>

